import thunk from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';

import rootReducer from './rootReducer';

let middleware;
// eslint-disable-next-line no-underscore-dangle
if (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__) {
  // eslint-disable-next-line no-underscore-dangle
  middleware = compose(applyMiddleware(thunk), window.__REDUX_DEVTOOLS_EXTENSION__());
} else {
  middleware = applyMiddleware(thunk);
}

const store = createStore(
  rootReducer,
  middleware
);

export default store;



// WEBPACK FOOTER //
// ./redux/store.js